import { update_question } from '@/services/question_service';
import { extract_error_message } from '@/utils/api_response_helpers';
import {
  assignQuestionsToSection,
  createQuestions,
} from './create_sections_question_helpers.js';
import {
  handleEditedQuestionSuccess,
  handleQuestionCreateSuccess,
  normalizeQuestionCrudError,
  validateEditedQuestion,
  validateQuestionCreateRequest,
} from './create_sections_question_crud_helpers.js';

function handleEditQuestionError(ctx, response) {
  const is_success = response?.status === 'success';
  if (!is_success) {
    ctx.show_error(response?.message || 'Failed to update question.');
  }
  return is_success;
}

function canSaveEditedQuestion(ctx) {
  return validateEditedQuestion(ctx);
}

async function persistEditedQuestion(ctx) {
  const response = await update_question(ctx.build_edit_question_payload());
  if (!handleEditQuestionError(ctx, response)) {
    return;
  }
  await handleEditedQuestionSuccess(ctx, response);
}

export const create_sections_question_crud_methods = {
  async save_all_questions() {
    const save_context = validateQuestionCreateRequest(this);
    if (!save_context) {
      return;
    }

    this.creating_question = true;
    const loader = await this.show_loader('Saving questions...');
    try {
      const created_question_ids = await createQuestions(this, save_context.section_id);
      if (!Array.isArray(created_question_ids) || !created_question_ids.length) {
        return;
      }

      const assign_response = await assignQuestionsToSection(
        created_question_ids,
        save_context.form_id,
        save_context.section_id
      );
      const parsed_assign_response = this.parse_response_data(assign_response);
      if (parsed_assign_response?.status === 'success') {
        await handleQuestionCreateSuccess(this, parsed_assign_response, save_context.section_id);
        return;
      }

      this.show_error(this.normalize_error_message(parsed_assign_response?.message, 'Failed to assign questions to section.'));
    } catch (error) {
      const message = normalizeQuestionCrudError(error, 'Failed to save questions.');
      this.show_error(this.normalize_error_message(message, 'Failed to save questions.'));
    } finally {
      await this.close_loader(loader);
      this.creating_question = false;
    }
  },

  async save_edited_question() {
    if (!canSaveEditedQuestion(this)) {
      return;
    }

    this.edit_question_error = false;
    this.editing_question = true;
    const loader = await this.show_loader('Saving question...');
    try {
      await persistEditedQuestion(this);
    } catch (error) {
      this.show_error(extract_error_message(error, 'Failed to update question.'));
    } finally {
      await this.close_loader(loader);
      this.editing_question = false;
    }
  },
};
